import React, { useEffect } from 'react';
import tema2 from '../../assets/tema2.png';
import tema3 from '../../assets/tema3-1.png';
import tema4 from '../../assets/tema4.png';
import famaillaImg from '../../assets/famailla.jpg'; // Asegurate de tener esta imagen también importada

interface Item {
    title: string;
    image: string;
    link: string;
}

export const Historia: React.FC = () => {
    const items: Item[] = [
        {
            title: "Comisión directiva",
            image: tema2,
            link: "/comision-directiva",
        },
        {
            title: "Logros",
            image: tema3,
            link: "/logros",
        },
        {
            title: "Eventos recreativos",
            image: tema4,
            link: "/eventos-recreativos",
        },
    ];

    useEffect(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' }); // O 'auto' si no querés animación
    }, []);

    return (
        <div style={{ display: "flex", margin: "40px auto", gap: "20px", marginLeft: '100px', marginRight: '100px' }}>
            {/* Contenido principal */}
            <div style={{ flex: "10", height: 'fit-content' }}>
                <h1>Historia del club</h1>
                <p style={{ fontWeight: '400' }}>
                    - Fundación: El Club Social y Deportivo Atlético Famaillá fue fundado el 8 de junio de 1908 en la Provincia de Tucumán, Argentina.<br />
                    - Primer presidente: El primer presidente del club fue Don Carlos Albarracín, quien formó parte oficial de la primera dirigencia del club.<br />
                    - Estadio: El estadio del club lleva el nombre de Ricardo Enrique Bochini, máximo ídolo del Club Atlético Independiente, y tiene una capacidad de 1800 a 4000 espectadores.<br />
                    - Colores del equipo: Los colores del primer equipo son azul cielo y blanco, con franjas verticales, motivo por el cual es conocido como "El Celeste".<br />
                    El 6 de Julio de 1975 el FAMA se consagró CAMPEÓN de primera en la ex Liga Cultural de Fútbol al vencer a Cruz Alta en tiempo suplementario por 2 a 1, Campero marcó para el vencedor en dos oportunidades. El partido se disputó en cancha de Atlético San Juan.
                </p>

                <img
                    src={famaillaImg}
                    alt="Historia del club"
                    style={{ width: "100%", height: "40%", borderRadius: "8px", margin: "20px 0" }}
                />

                <p style={{ fontWeight: '400' }}>
                    Formación: Figueroa; M.Ferro, Córdoba, Prats, Sleiman; Nassif, Cisneros, Oscar Ferro; Palma, Flores, Campero
                </p>
                <p style={{ fontWeight: '400' }}>
                    - Participación en competencias nacionales: El club ha disputado varios campeonatos nacionales, entre ellos, la Copa Argentina, el Torneo Argentino B, Torneo Federal B, el Torneo Federal C y el Torneo del Interior.
                </p>
                <p style={{ fontStyle: "italic", marginTop: "20px" }}>Escrito por: Mauris Acfelis Tellus</p>
            </div>

            {/* Barra lateral */}
            <div style={{ flex: "4" }}>
                <div style={{ padding: "20px" }}>
                    <h3 style={{ fontFamily: "'Arial', sans-serif" }}>Seguir leyendo...</h3>
                    <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                        {items.map((item, index) => (
                            <a
                                key={index}
                                href={item.link}
                                style={{
                                    display: "block",
                                    position: "relative",
                                    borderRadius: "15px",
                                    overflow: "hidden",
                                    textDecoration: "none",
                                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                    backgroundImage: `url(${item.image})`,
                                    backgroundSize: "cover",
                                    backgroundPosition: "center",
                                    height: "150px",
                                }}
                            >
                                <div
                                    style={{
                                        position: "absolute",
                                        bottom: "0",
                                        width: "100%",
                                        background: "rgba(0, 0, 0, 0.6)",
                                        color: "white",
                                        padding: "10px",
                                        fontSize: "18px",
                                        textAlign: "center",
                                        fontWeight: "bold",
                                    }}
                                >
                                    {item.title}
                                </div>
                            </a>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};
